var map = {
	"./bankvault.png": "b8a5",
	"./brainstorm.png": "ff0a",
	"./faces.png": "7ee7",
	"./shopping.png": "1d41",
	"./timemachine.png": "16d2",
	"./vocabguru.png": "e8d4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f778";